import { ModuleFE_LaunchUrls } from './ModuleFE_LaunchUrls.js';
export const ModulePackFE_LaunchUrls = [ModuleFE_LaunchUrls];
//# sourceMappingURL=module-pack.js.map